// components/BannerDisplay.jsx
//
// Fetches active banners from the backend and displays them at the top
// of the homepage. Fully database-driven - when admin adds/edits/
// deletes/toggles a banner, this reflects it automatically on next
// page load, no code change needed.
//
// If there are zero active banners, this renders nothing (no empty
// gap on the page).

import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config';

function BannerDisplay() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(`${API_BASE}/banners`);
        const data = await res.json();
        setBanners(data);
      } catch (err) {
        // Fail silently - a broken banner fetch shouldn't block the
        // rest of the homepage (products, search, etc.) from working
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBanners();
  }, []);

  if (loading || banners.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '20px 20px 0' }}>
      {banners.map((banner) => (
        <div
          key={banner._id}
          className="hud"
          style={{
            position: 'relative',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '1100px',
            margin: '0 auto',
            width: '100%',
          }}
        >
          <img
            src={banner.imageUrl}
            alt={banner.title || 'Banner'}
            style={{ width: '100%', display: 'block', maxHeight: '320px', objectFit: 'cover' }}
          />
          {(banner.title || banner.description) && (
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(to top, rgba(10,14,23,0.92) 0%, rgba(10,14,23,0.55) 60%, transparent 100%)',
                padding: '24px 20px 18px',
              }}
            >
              {banner.title && (
                <h2 className="display" style={{ margin: '0 0 6px', fontSize: '24px', color: '#fff' }}>
                  {banner.title}
                </h2>
              )}
              {banner.description && (
                <p style={{ margin: 0, fontSize: '14px', color: '#e2e6ef', maxWidth: '640px', lineHeight: '1.5' }}>
                  {banner.description}
                </p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default BannerDisplay;
